
    import {useStore} from "@/store";
    // , computed, ComputedRef, watch, reactive
    import  reportMsgUt from "@/util/reportMsg";
    import {defineComponent, watch, reactive, toRefs} from "vue";
    import {useRouter,useRoute} from "vue-router";

interface State {
    reportMsg: object;
    templateCode: string;
}
export default defineComponent({
    name: 'checkTitle',
    props: {
        itemCode: {
            type: String,
            default: ''
        },
        titleCont: {
            type: String,
            default: ''
        },
        count: {
            type: Number,
            default: 0
        }
    },
    setup() {
        let state: State = reactive({
            reportMsg: {},
            templateCode: ''

        })
        state.reportMsg = reportMsgUt;

        let store = useStore()
        // 获取路由器实例
        const router = useRouter()
        const {query} = useRoute();
        const { templateCode} = query;
        state.templateCode = String(templateCode);
        return {
            store,
            state,
            router
        }
    },
    methods: {
        handleClick(checkTitle){
            this.store.dispatch('savePageScrollTop', window.scrollY);
            this.router.push({
                path: '/tocZQYCheckStandard',
                query: {
                    checkTitle,
                    templateCode: this.state.templateCode
                }
            })
        }
    }
})
